export const marketPath = process.env.REACT_APP_LINK_MARKETPLACE || 'https://marketplace.viakonnect.com';
export const whatsApp = process.env.REACT_APP_WHATSAPP || '33648517574';
